import React, { useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ClickAwayListener } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import * as Loaders from '~/components/Loaders';
import * as actions from '~/store/actions';
import * as lib from '~/dependencies';
import log from '~/helpers/log';
import messagesToast from '~/validations/messagesNotifications';
import * as NuacomComponent from '~/components';
import { Container, Tag, Title } from './styles';

export default function ShowTags({ callId }) {
  // STATES
  const [idToRemove, setIdToRemove] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  // MEMOS
  const callIdMemo = useMemo(() => callId, [callId]);

  // HOOKS
  const dispatch = useDispatch();
  const { t } = lib.useTranslation();

  // SELECTORS
  const loading = useSelector(state => state?.tags?.loading);
  const allTags = useSelector(state => state?.tags?.data);

  // Get tags by callId than filter for assigned
  const callTags = allTags[callIdMemo]
    ? allTags[callIdMemo].filter(e => e.assigned === 1)
    : [];

  // EFFECTS
  useEffect(() => {
    const id = callIdMemo && (callIdMemo?.raw || callIdMemo);
    dispatch(actions.getTagsByCallId(id));
  }, [dispatch, callIdMemo]);

  async function removeTag() {
    try {
      const tagId = Number(idToRemove);
      dispatch(actions.deleteTagById(callId, tagId));

      // The app feedback to users, tags was deleted
      setTimeout(() => {
        lib.ToastMessage('success', messagesToast().CALLS.tags.delete.success);
      }, 500);
    } catch (err) {
      log.error('Failed to delete tag by ID.', err);
    }
  }

  function deleteTag(tagId) {
    if (tagId) {
      setOpenModal(true);
      setIdToRemove(tagId);
    }
  }

  function confirmUnassign(hasConfirm) {
    if (hasConfirm) {
      removeTag();
    } else {
      setIdToRemove(null);
    }
  }

  return (
    <>
      <ClickAwayListener onClickAway={() => setIdToRemove(null)}>
        <Container className="showtags-container">
          {loading ? (
            <>
              <Title>{t('components.showTags.title')}</Title>
              <Loaders.Line size="290" />
            </>
          ) : (
            <>
              {callTags?.length ? (
                <div className="tag-list">
                  <div className="header">
                    <Title>Tags Added:</Title>
                  </div>

                  <div className="content">
                    {callTags.map(tag => (
                      <Tag
                        key={tag.tag_id}
                        color={tag.tag_color}
                        onClick={() => deleteTag(tag.tag_id)}>
                        <div className="circle">
                          <Close className="icon-delete" />
                          <span className="tag-name">{tag.tag_name}</span>
                        </div>
                      </Tag>
                    ))}
                  </div>
                </div>
              ) : null}
            </>
          )}

          <NuacomComponent.ConfirmationBox
            setOpenModal={setOpenModal}
            openModal={openModal}
            handleAction={confirmUnassign}
          />
        </Container>
      </ClickAwayListener>
    </>
  );
}

ShowTags.defaultProps = {
  callId: null,
};

ShowTags.propTypes = {
  callId: lib.PropTypes.string,
};
